import * as React from 'react'
import Stack from '@mui/material/Stack'
import { PreviewBody, PreviewHeader } from '../styled'
import { IReferral } from '@sales-center/common'
import { EmployeeDisplay } from './EmployeeDisplay'

export type Props = {
  employeeListStatus: 'pending' | 'success' | 'fail'
  referral: IReferral
}

export function EmployeePreview(props: Props) {
  return (
    <Stack>
      <PreviewHeader>Employee</PreviewHeader>
      <PreviewBody>
        <>
          Employee Name: <EmployeeDisplay {...props} />
        </>
      </PreviewBody>
    </Stack>
  )
}
